/* ==========================================================================
   FXT Racing theme: product.js (loaded on product pages only)
   Gallery, variant selection through the Section Rendering API, bike
   fitment checker, AJAX add to cart, sticky add-to-cart bar, related products.
   ========================================================================== */
(function () {
  'use strict';

  var strings = window.themeStrings || {};

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function announce(message) { if (window.FXT) window.FXT.announce(message); }
  function reducedMotion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  /* ---------- Gallery ---------- */
  function initGallery(section) {
    var gallery = qs('[data-gallery]', section);
    var track = gallery && qs('[data-gallery-track]', gallery);
    if (!track) return { goToImage: function () {} };

    var slides = qsa('.gallery__slide', track);
    var thumbs = qsa('[data-gallery-thumb]', gallery);
    var prev = qs('[data-gallery-prev]', gallery);
    var next = qs('[data-gallery-next]', gallery);
    var counter = qs('[data-gallery-counter]', gallery);
    var index = 0;
    var raf = null;
    var settleUntil = 0;

    function setActive(i) {
      index = i;
      thumbs.forEach(function (thumb, n) {
        var active = n === i;
        thumb.classList.toggle('is-active', active);
        if (active) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }

    function goTo(i, instant) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      // Ignore scroll events caused by this programmatic scroll so the counter does not flicker.
      settleUntil = Date.now() + (instant || reducedMotion() ? 120 : 700);
      track.scrollTo({ left: i * track.clientWidth, behavior: instant || reducedMotion() ? 'auto' : 'smooth' });
      setActive(i);
    }

    track.addEventListener('scroll', function () {
      if (raf || Date.now() < settleUntil) return;
      raf = window.requestAnimationFrame(function () {
        raf = null;
        var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
        if (i !== index) setActive(i);
      });
    }, { passive: true });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
    });

    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { goTo(parseInt(thumb.getAttribute('data-index'), 10) || 0); });
    });

    window.addEventListener('resize', function () { goTo(index, true); });

    var initial = parseInt(section.getAttribute('data-initial-index'), 10) || 0;
    setActive(initial);
    if (initial > 0) window.requestAnimationFrame(function () { goTo(initial, true); });

    return {
      goToImage: function (imageId) {
        for (var n = 0; n < slides.length; n += 1) {
          if (String(slides[n].getAttribute('data-image-id')) === String(imageId)) {
            goTo(n);
            return;
          }
        }
      }
    };
  }

  /* ---------- Bike fitment checker ---------- */
  function initFitment(section) {
    var box = qs('[data-fitment]', section);
    if (!box) return;
    var select = qs('[data-fitment-select]', box);
    var result = qs('[data-fitment-result]', box);
    var remember = qs('[data-fitment-remember]', box);
    if (!select || !result) return;

    var fits = (box.getAttribute('data-fits') || '').split(',').filter(Boolean);
    var msgFits = box.getAttribute('data-msg-fits') || '';
    var msgUnlisted = box.getAttribute('data-msg-unlisted') || '';
    var KEY = 'fxt:bike';

    function store(value) {
      try {
        if (value) window.localStorage.setItem(KEY, value);
        else window.localStorage.removeItem(KEY);
      } catch (err) { /* storage can be blocked; the checker still works */ }
    }
    function read() {
      try { return window.localStorage.getItem(KEY); } catch (err) { return null; }
    }

    function evaluate() {
      var handle = select.value;
      result.className = 'fitment__result';
      if (!handle) {
        result.textContent = '';
        return;
      }
      var name = select.options[select.selectedIndex].text;
      var isFit = fits.indexOf(handle) > -1;
      result.textContent = (isFit ? msgFits : msgUnlisted).replace('{bike}', name);
      result.classList.add(isFit ? 'is-fit' : 'is-unlisted');
    }

    select.addEventListener('change', function () {
      evaluate();
      if (remember && remember.checked) store(select.value);
    });
    if (remember) {
      remember.addEventListener('change', function () {
        store(remember.checked ? select.value : '');
      });
    }

    var saved = read();
    if (saved && qs('option[value="' + saved.replace(/"/g, '') + '"]', select)) {
      select.value = saved;
      if (remember) remember.checked = true;
      evaluate();
    }
  }

  /* ---------- Variants, dynamic regions and add to cart ---------- */
  function initPurchase(section, gallery) {
    var form = qs('[data-product-form]', section);
    if (!form) return;

    var picker = qs('[data-variant-picker]', section);
    var idInput = qs('input[name="id"]', form);
    var errorEl = qs('[data-product-error]', section);
    var qtyInput = qs('input[name="quantity"]', form);
    var sectionId = section.getAttribute('data-section-id');
    var productUrl = section.getAttribute('data-product-url');
    var product = null;
    var cache = {};
    var controller = null;
    var currentId = idInput ? String(idInput.value) : '';
    var submitting = false;

    try {
      var json = qs('[data-product-json]', section);
      product = json ? JSON.parse(json.textContent) : null;
    } catch (err) {
      product = null;
    }

    function buttons() { return qsa('[data-add-to-cart], [data-sticky-button]', section); }
    function labelOf(button) { return qs('[data-add-to-cart-text]', button) || button; }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message || '';
      errorEl.hidden = !message;
    }

    function variantOptions(variant) {
      if (variant.options && variant.options.length) return variant.options;
      return [variant.option1, variant.option2, variant.option3].filter(function (v) { return v != null; });
    }

    function selectedOptions() {
      var values = [];
      qsa('[data-option-index]', picker).forEach(function (fieldset) {
        var i = parseInt(fieldset.getAttribute('data-option-index'), 10);
        var select = qs('[data-option-select]', fieldset);
        var checked = qs('input[type="radio"]:checked', fieldset);
        values[i] = select ? select.value : (checked ? checked.value : undefined);
      });
      return values;
    }

    function findVariant(values) {
      if (!product) return null;
      for (var n = 0; n < product.variants.length; n += 1) {
        var opts = variantOptions(product.variants[n]);
        var match = true;
        for (var i = 0; i < values.length; i += 1) {
          if (opts[i] !== values[i]) { match = false; break; }
        }
        if (match) return product.variants[n];
      }
      return null;
    }

    // Strike through option values that have no purchasable variant for the current picks.
    function markAvailability(values) {
      if (!product) return;
      qsa('[data-option-index]', picker).forEach(function (fieldset) {
        var i = parseInt(fieldset.getAttribute('data-option-index'), 10);
        qsa('.variant-option', fieldset).forEach(function (wrap) {
          var input = qs('input', wrap);
          var label = qs('label', wrap);
          if (!input || !label) return;
          var purchasable = product.variants.some(function (variant) {
            if (!variant.available) return false;
            var opts = variantOptions(variant);
            if (opts[i] !== input.value) return false;
            return values.every(function (v, j) { return j === i || v === undefined || opts[j] === v; });
          });
          label.classList.toggle('is-unavailable', !purchasable);
        });
      });
    }

    function applyDynamic(doc) {
      ['price', 'meta', 'buy', 'sticky'].forEach(function (name) {
        var fresh = qs('[data-dynamic="' + name + '"]', doc);
        var live = qs('[data-dynamic="' + name + '"]', section);
        if (fresh && live) live.innerHTML = fresh.innerHTML;
      });
    }

    function loadDynamic(variantId) {
      if (cache[variantId]) {
        applyDynamic(cache[variantId]);
        return;
      }
      if (controller) controller.abort();
      controller = typeof AbortController === 'function' ? new AbortController() : null;
      var joiner = productUrl.indexOf('?') > -1 ? '&' : '?';
      var url = productUrl + joiner + 'variant=' + encodeURIComponent(variantId) + '&section_id=' + encodeURIComponent(sectionId);
      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          cache[variantId] = doc;
          if (String(variantId) === currentId) applyDynamic(doc);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          // Leave the current regions as they are; the add-to-cart request still uses the right variant id.
        });
    }

    function setUnavailable() {
      buttons().forEach(function (button) {
        button.disabled = true;
        labelOf(button).textContent = strings.unavailable || 'Unavailable';
      });
    }

    function onOptionChange() {
      if (!picker) return;
      var values = selectedOptions();
      markAvailability(values);
      var variant = findVariant(values);
      showError('');
      if (!variant) {
        setUnavailable();
        return;
      }
      if (String(variant.id) === currentId) {
        loadDynamic(variant.id);
        return;
      }
      currentId = String(variant.id);
      if (idInput) {
        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (variant.featured_image && variant.featured_image.id) gallery.goToImage(variant.featured_image.id);
      loadDynamic(variant.id);
    }

    if (picker) {
      picker.addEventListener('change', onOptionChange);
      markAvailability(selectedOptions());
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        var value = parseInt(qtyInput.value, 10);
        if (isNaN(value) || value < 1) qtyInput.value = 1;
      });
    }

    /* Add to cart through the cart drawer; falls back to a normal form post. */
    form.addEventListener('submit', function (e) {
      if (!window.FXT || !window.FXT.cart) return;
      e.preventDefault();
      if (submitting) return;
      submitting = true;
      showError('');

      var active = buttons();
      active.forEach(function (button) {
        var label = labelOf(button);
        button._label = label.textContent;
        button._wasDisabled = button.disabled;
        button.disabled = true;
        label.textContent = strings.adding || 'Adding...';
      });

      function restore() {
        submitting = false;
        active.forEach(function (button) {
          if (button._label === undefined) return;
          labelOf(button).textContent = button._label;
          button.disabled = button._wasDisabled;
        });
      }

      window.FXT.cart.add(form)
        .then(function () {
          active.forEach(function (button) { labelOf(button).textContent = strings.added || 'Added'; });
          announce(strings.added);
          window.FXT.cart.open();
          window.setTimeout(restore, 1500);
        })
        .catch(function (err) {
          showError(err.message || strings.error);
          restore();
        });
    });
  }

  /* ---------- Sticky add-to-cart bar (small screens) ---------- */
  function initSticky(section) {
    var bar = qs('[data-sticky-atc]', section);
    var anchor = qs('.qty-and-buy', section);
    if (!bar || !anchor) return;
    var ticking = false;
    function update() {
      ticking = false;
      // Show the bar once the main add-to-cart row has scrolled out of view above the viewport.
      bar.classList.toggle('is-visible', anchor.getBoundingClientRect().bottom < 0);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* ---------- Related products, loaded when they are about to scroll into view ---------- */
  function initRecommendations(el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    function load() {
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = qs('[data-recommendations]', doc);
          if (fresh && fresh.innerHTML.trim()) {
            el.innerHTML = fresh.innerHTML;
            if (window.FXT) window.FXT.observeReveal(el);
          }
        })
        .catch(function () { /* related products are optional */ });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          io.disconnect();
          load();
        }
      }, { rootMargin: '500px 0px' });
      io.observe(el);
    } else {
      load();
    }
  }

  qsa('[data-product-section]').forEach(function (section) {
    var gallery = initGallery(section);
    initFitment(section);
    initPurchase(section, gallery);
    initSticky(section);
  });
  qsa('[data-recommendations]').forEach(initRecommendations);
})();
